import { CfSectionScrollItemProps } from "../types";
import React from "react";
import SectionScrollItem from "../index";
import parse from "html-react-parser";

export const convertCfSectionScrollItemProps = ({
  slug,
  title,
  abstract,
  isSidebar = false,
  children,
}: CfSectionScrollItemProps) => ({
  slug,
  title: parse(title),
  abstract: abstract?.abstract ? parse(abstract.abstract) : "",
  isSidebar,
  children,
});

const CfSectionScrollItem = (props: CfSectionScrollItemProps) => (
  <SectionScrollItem {...convertCfSectionScrollItemProps(props)} />
);

export default CfSectionScrollItem;
